import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import HistoryQPage1, { IProps } from './index';
import { InputFieldConfig } from '../../../../types';
import { getPageStatus } from './utils';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    LastCourse: lastCourseConfig,
    LastCourseOther: lastCourseOtherConfig,
    LastCourseYear: lastCourseYearConfig,
    HasOverseasTravel: hasOverseasTravelConfig,
    OverseasTravelTimes: overseasTravelTimesConfig,
    HasUKTravel: hasUkTravelConfig,
    UKTravelTimes: ukTravelTimesConfig,
    HasPreviousUkStudy: hasPreviousUkStudyConfig,
    HasPreviousUkStudyVisa: hasPreviousUkStudyVisaConfig,
    LastCourseLevel: lastCourseLevelConfig,
    LowerOrSameLevelReason: lowerOrSameLevelReasonConfig,
  }: {
    LastCourse: InputFieldConfig;
    LastCourseOther: InputFieldConfig;
    LastCourseYear: InputFieldConfig;
    HasOverseasTravel: InputFieldConfig;
    OverseasTravelTimes: InputFieldConfig;
    HasUKTravel: InputFieldConfig;
    UKTravelTimes: InputFieldConfig;
    HasPreviousUkStudy: InputFieldConfig;
    HasPreviousUkStudyVisa: InputFieldConfig;
    LastCourseLevel: InputFieldConfig;
    LowerOrSameLevelReason: InputFieldConfig;
  } = state.student.config.Checklist.History.Page1;

  const defaultValues = {
    lastCourse: '',
    lastCourseOther: '',
    lastCourseYear: '',
    hasOverseasTravel: undefined,
    overseasTravelTimes: '',
    hasUkTravel: undefined,
    ukTravelTimes: '',
    hasPreviousUkStudy: undefined,
    hasPreviousUkStudyVisa: undefined,
    previousUkStudyVisas: [],
  };

  const {
    lastCourse,
    lastCourseOther,
    lastCourseYear,
    hasOverseasTravel,
    overseasTravelTimes,
    hasUkTravel,
    ukTravelTimes,
    hasPreviousUkStudy,
    hasPreviousUkStudyVisa,
    previousUkStudyVisas,
    lastCourseLevel,
    lowerOrSameLevelReason,
  } = { ...defaultValues, ...state.student.history };

  const { complete, visible } = getPageStatus(state.student.config, {
    lastCourse,
    lastCourseOther,
    lastCourseYear,
    hasOverseasTravel,
    overseasTravelTimes,
    hasUkTravel,
    ukTravelTimes,
    hasPreviousUkStudy,
    hasPreviousUkStudyVisa,
    previousUkStudyVisas,
    lastCourseLevel,
    lowerOrSameLevelReason,
  });

  const {
    lastCourse: lastCourseVisible,
    lastCourseOther: lastCourseOtherVisible,
    lastCourseYear: lastCourseYearVisible,
    hasOverseasTravel: hasOverseasTravelVisible,
    overseasTravelTimes: overseasTravelTimesVisible,
    hasUkTravel: hasUkTravelVisible,
    ukTravelTimes: ukTravelTimesVisible,
    hasPreviousUkStudy: hasPreviousUkStudyVisible,
    hasPreviousUkStudyVisa: hasPreviousUkStudyVisaVisible,
    lastCourseLevel: lastCourseLevelVisible,
    lowerOrSameLevelReason: lowerOrSameLevelReasonVisible,
  } = visible;

  return {
    sectionTitle: state.student.config.Checklist.History.shortTitle,
    complete,
    currentStep: 1,
    steps: 3,
    lastCourse,
    lastCourseVisible,
    lastCourseConfig,
    lastCourseOther,
    lastCourseOtherVisible,
    lastCourseOtherConfig,
    lastCourseYear,
    lastCourseYearVisible,
    lastCourseYearConfig,
    hasOverseasTravel,
    hasOverseasTravelVisible,
    hasOverseasTravelConfig,
    overseasTravelTimes,
    overseasTravelTimesVisible,
    overseasTravelTimesConfig,
    hasUkTravel,
    hasUkTravelVisible,
    hasUkTravelConfig,
    ukTravelTimes,
    ukTravelTimesVisible,
    ukTravelTimesConfig,

    hasPreviousUkStudyVisa,
    hasPreviousUkStudyVisaVisible,
    hasPreviousUkStudyVisaConfig,
    hasPreviousUkStudy,
    hasPreviousUkStudyVisible,
    hasPreviousUkStudyConfig,

    lastCourseLevel,
    lastCourseLevelVisible,
    lastCourseLevelConfig,
    lowerOrSameLevelReason,
    lowerOrSameLevelReasonVisible,
    lowerOrSameLevelReasonConfig,

    previousUkStudyVisas: previousUkStudyVisas?.length ? previousUkStudyVisas : [],
    config: state.student.config,
    isPageComplete: state.student.offer.isHPage1Complete,
    importData: state.student.importData,
  };
};

export default connect(mapStateToProps)(HistoryQPage1);
